import { createAction } from '@reduxjs/toolkit'

export const postKProjectDates = createAction(
  'algorithmsView/postKProjectDates'
)

export const postIntervalTest = createAction('algorithmsView/postIntervalTest')
